import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toastInformation } from "../../../base/callService/common";
//*import { ChatService } from "../../../base/chatService";
import { DraftService } from "../../../base/draftService";
//*import { SocketChatService } from "../../../base/socketChatService";
//*import { userInfo } from "../../../base/socketChatService/utils";
import DropBoxUpload from "../../../components/chat/chatWidgets/dropboxDriveStorage/dropboxUpload";
import GoogleCloudStorage from "../../../components/chat/chatWidgets/googleDriveStorage";
import OneDriveStorageModal from "../../../components/chat/chatWidgets/oneDrive/oneDriveStorage";
import { actionTypes } from "../../../context/action/action";
//*import { chatSocketReducerState } from "../../../context/reducer/chatSocketReducer";
import store from "../../../context/store/store";
import { chatSocketReducerStateModel, chatwindowDetails, initialStateModel } from "../../../models/model";
// import { URInput } from "../input";
import styles from "./chatAttached.module.scss";
import sharegreen from "../../../styles/images/sharegreen-icon.svg"
import GoogleDrive from "../../../components/chat/chatWidgets/googleDriveStorage/googleDrivePack";
import BoxStorage from "../../../components/chat/chatWidgets/boxStorage/boxStorageCom";
import { Modal, Popover, Select } from "antd";
import { URButton } from "../button";
import evernoteIcn from "../../../styles/images/evernote-icon-mdl.svg"
import evernoteIcnNodata from "../../../styles/images/nodataEvernote.svg"

import { URInput } from "../input";
import { EvernoteStorage } from "../../../components/chat/chatWidgets/Evernote";
// import mail2 from "../../styles/images/1b.png";

//*type image ={
//*    imageUrl:any;
//*}

function URChatAttached(props: any) {
  const { filesAttach }: chatSocketReducerStateModel = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  let { chatWindowDetails }: chatwindowDetails = { ...store.getState().chatWindowReducer };
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  /**
   * @description FileUpload
   * @param e 
   */
  const uploadFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("e. target fi;es---------", e.target.files)
    let selectedFile: any = e.target.files;
    console.log("files-------------", selectedFile)
    if (selectedFile.length < 11) {
      //*let filesinfo:any = {};
      let attachedFile = store.getState().chatSocketReducerState;
      let filesinfoArray = attachedFile.filesAttach || [];
      for (let i = 0; i < selectedFile.length; i++) {
        if (selectedFile[i].type !== "") {
          if (selectedFile[i].type !== 'text/csv') {
            console.log("selectedFile[i]0--------------", selectedFile[i])
            filesinfoArray.push({
              fileName: selectedFile[i].name,
              fileType: selectedFile[i].type,
              filesize: selectedFile[i].size,
              filePath: window.URL.createObjectURL(selectedFile[i]),
              targetFile: selectedFile[i],
              txt: "",
              messageType: "FILE",
              isCloudfiles: false
            })
          } else {
            toastInformation('Unsupported file type.Choose another file', 'failure');
          }
        } else {
          toastInformation('Unsupported file type.Choose another file', 'failure');
        }
      }
      console.log("helpp-----", filesinfoArray)
      DraftService.updateDraftMessage(chatWindowDetails, "", filesinfoArray);
      store.dispatch({
        type: actionTypes.FILE_ATTACHMENTS,
        payload: {
          filesAttach: filesinfoArray
        }
      });
    }
    else {
      toastInformation("More than 10 Files not allowing", "failure");
    }
    e.target.value = ''
  };

  return (
    <>
      <div className={styles.popOverContainer}>
        <div className={styles.listdrapdrop}>
          <ul className={styles.orderItem} onClick={() => props.hideAttach()}>
            <li>
              <label>Drag & drop files from your computer (or) Upload from...</label>
            </li>
            <li>
              <span className="icon_computer"></span> Your computer
              <img src="" alt="" />
              <span className={styles.file_upload_input}>
                {!filesAttach && <input
                  id="input"
                  type="file"
                  ref={props.inputFileRef}
                  multiple
                  onChange={uploadFile}
                ></input>}
                {filesAttach &&
                  <input
                    ref={props.inputFileRef}
                    id="input"
                    type="file"
                    multiple
                    onChange={uploadFile}

                  ></input>}
              </span>
            </li>

            
              
              <>
              <DropBoxUpload></DropBoxUpload>
              <GoogleDrive></GoogleDrive>
              <BoxStorage />
              <OneDriveStorageModal></OneDriveStorageModal>
              <EvernoteStorage/>
              </>
            {/* <GoogleCloudStorage></GoogleCloudStorage> */}
            {/* <li><span><img src={sharegreen} /></span> Share contacts</li> */}
          </ul>
        </div>
      </div>


      {/* <Modal className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>One Drive</h2>
          <ul>
            <li><Tooltip placement="top" title={'Close'}
            >
              <span className="icon_close">
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="chatNoteImgContent">
          
        </div>
        
      </Modal> */}




   
    </>
  );
}

export {
  URChatAttached
};